var map = {
	"./_module_demo_/my/NavsAsideExtends.js": 37615,
	"./menu-management/my/NavsAsideExtends.js": 71356,
	"./sport-hub-league/my/NavsAsideExtends.js": 50438,
	"./sport-hub/my/NavsAsideExtends.js": 80484,
	"./waitress-order-ticket/my/NavsAsideExtends.js": 83969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38955;